import { createTV } from 'tailwind-variants';

import { DEFAULT_MERGE_CONFIG } from './mergeClasses';

export const variants = createTV({ twMergeConfig: DEFAULT_MERGE_CONFIG });

export type { VariantProps } from 'tailwind-variants';
